import { render } from "./FacebookSvg.vue?vue&type=template&id=436aa101&bindings={}"
import script from "./FacebookSvg.vue?vue&type=script&lang=ts"
export * from "./FacebookSvg.vue?vue&type=script&lang=ts"
script.render = render

export default script